import { strFromU8, strToU8, unzipSync, zipSync } from 'fflate';
import { templateBytes } from '../sku-consolidation/excel';
import type { Result } from './types';

const escape = (value: string) => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/g, '');
const status = { pending: 'Pendiente', ready: 'Listo para aplicar', created: 'Plantilla aplicada', skipped: 'Omitido', error: 'Error' };
export function resultsBytes(rows: Result[]): Uint8Array {
  const headers = ['SKU', 'Plantilla aplicada', 'Modelo creado', 'Modelo ya existía', 'Enlace ficha', 'Estado', 'Detalle'];
  const values = [headers, ...rows.map(row => [row.sku, row.status === 'created' ? 'Sí' : 'No',
    row.modelCreated === undefined ? '' : row.modelCreated ? 'Sí' : 'No',
    row.modelExisted === undefined ? '' : row.modelExisted ? 'Sí' : 'No', row.url ?? '', status[row.status],
    [row.error?.message, row.message, row.linkError].filter(Boolean).join(' · ')])];
  const files = unzipSync(templateBytes('sameSku', headers, 'Resultados'));
  // Inline strings preserve SKUs and prevent spreadsheet formulas from executing.
  let sheet = strFromU8(files['xl/worksheets/sheet1.xml']);
  sheet = sheet.replace(/<sheetData>[\s\S]*?<\/sheetData>/, `<sheetData>${values.map((row, index) =>
    `<row r="${index + 1}">${row.map((value, column) => `<c r="${String.fromCharCode(65 + column)}${index + 1}" s="1" t="inlineStr"><is><t xml:space="preserve">${escape(value)}</t></is></c>`).join('')}</row>`).join('')}</sheetData>`);
  files['xl/worksheets/sheet1.xml'] = strToU8(sheet);
  return zipSync(files);
}
